import axios from 'axios'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  faChartArea,
  faCity,
  faDrawPolygon,
  faEye,
  faEyeSlash,
  faFlag,
  faFloppyDisk,
  faLocationPinLock,
  faMapLocation,
  faRedo,
  faSearch,
  faUndo,
} from '@fortawesome/free-solid-svg-icons'
import { GoogleMap, Marker, Polygon, Polyline } from '@react-google-maps/api'
import { Form, InputRef } from 'antd'
import { kinks, polygon as turfPolygon } from '@turf/turf'

//STYLE
import { ContainerDesenho } from './styles'

//APP
import { buscaCidade, calculoAreaCoord, centerMap, listUf, polyGetPath } from '../../../../../services/Afins'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../utils/alert'
import { geralKmlPolygon } from '../../../../../Components/gerarKml'
import { postTalhaoCultivavel, putTalhaoCultivavel } from '../../../../../services/TalhaoSafra'
import { postTalhao, putTalhao } from '../../../../../services/Talhao'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import { Select } from '../../../../../Components/CustomUi/Select'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../Components/CustomUi/inline'
import { TitleH3 } from '../../../../../Components/CustomUi/titleH3'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'

export interface TypesDesenhoTalhao {
  propriedade: number
  update: number
  visible?: boolean
  onClose?: (data: boolean) => void
  atualizar: (codPro: number, nome: string) => void
  cultivavel: boolean
  dataPolygon?: {
    coordenadas?: google.maps.LatLng[]
    nome?: string
    lookat?: google.maps.LatLng
  }
}

const DesenhaTalhaoNovo: React.FC<TypesDesenhoTalhao> = (props) => {
  const { propriedade, update, atualizar, cultivavel, onClose, dataPolygon = { coordenadas: [] } } = props

  const inputRef = useRef<InputRef>(null)

  const [form] = Form.useForm()

  const [getPath, setPath] = useState<google.maps.LatLng[]>([])
  const [getAreatalhao, setGetAreatalhao] = useState<number>(0)
  const [getCenter, setCenter] = useState<google.maps.LatLng | google.maps.LatLngLiteral>({
    lat: -18.4590515,
    lng: -64.3517889,
  })
  const [uf, setUf] = useState<string>('')
  const [openUf, setOpenUf] = useState<boolean>(false)
  const [cidade, setCidade] = useState<string>('')
  const [cidadeId, setCidadeId] = useState<number>(null)
  const [openCidade, setOpenCidade] = useState<boolean>(false)
  const [longitude, setLongitude] = useState<string>('')
  const [latitude, setLatitude] = useState<string>('')
  const [nome, setNome] = useState<string>('')
  const [area, setArea] = useState<string>('')

  const [kinksPoints, setKinksPoints] = useState<{ lat: number; lng: number }[]>([])

  const [getZoom, setZoom] = useState<number>(4)

  const [typeBusca, setTypeBusca] = useState(false)

  const [getlistUf, setListUf] = useState([])

  const [getlistCity, setListCity] = useState([])

  const [undoPolygon, setUndoPolygon] = useState([])
  const [redoPolygon, setRedoPolygon] = useState([])

  const [getLoadingBuscaCoord, setLoadingBuscaCoord] = useState(false)

  const [drawingPoints, setDrawingPoints] = useState<google.maps.LatLngLiteral[]>([])
  const [isDrawingMode, setIsDrawingMode] = useState(true)

  const [encolher_card_localizacao, setEncolher_card_localizacao] = useState<boolean>(true)
  const [open_delete, setOpen_delete] = useState<boolean>(false)

  const [polygon, setPolygon] = useState<google.maps.Polygon>()

  const mapRef = useRef(null)

  const listenersRef = useRef([])

  const onUnmount = useCallback(() => {
    listenersRef.current.forEach((lis) => lis.remove())
  }, [])

  const validateKinks = (coordinates) => {
    try {
      if (coordinates.length < 4) return []
      const coords = coordinates.map((c) => [c.lng, c.lat])
      coords.push(coords[0])
      const poly = turfPolygon([coords])
      const intersectKinks = kinks(poly)
      if (intersectKinks.features.length > 0) {
        return intersectKinks.features.map((feature) => ({
          lng: feature.geometry.coordinates[0],
          lat: feature.geometry.coordinates[1],
        }))
      }
      return []
    } catch {
      return []
    }
  }

  const handleListUf = async () => {
    const response = await listUf()
    setListUf(response)
  }

  const handleUndo = () => {
    const old = [...undoPolygon]
    const index = undoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          newArray = [...newArray, data]
        } else {
          setRedoPolygon([...redoPolygon, data])
          newCoord = [old[i - 1]]
        }
      }
    })

    polygon.setPaths(newCoord)
    setGetAreatalhao(calculoAreaCoord(newCoord))
    setArea(String(calculoAreaCoord(newCoord)))
    setUndoPolygon(newArray)
  }

  const onLoadMap = () => {
    //
  }

  const handleRedo = () => {
    const old = [...redoPolygon]
    const index = redoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          newArray = [...newArray, data]
        } else {
          setUndoPolygon([...undoPolygon, data])
          newCoord = [old[i]]
        }
      }
    })

    polygon.setPaths(newCoord)
    setGetAreatalhao(calculoAreaCoord(newCoord))
    setArea(String(calculoAreaCoord(newCoord)))
    setRedoPolygon(newArray)
  }

  const handleResetDesenho = () => {
    setUndoPolygon([])
    setRedoPolygon([])
    setDrawingPoints([])
    setIsDrawingMode(false)
    setPath([])
    polygon?.setPaths([])
    setArea('')
    setNome('')
    setKinksPoints([])
    setGetAreatalhao(0)
  }

  const handleMapClick = (e: google.maps.MapMouseEvent) => {
    if (!isDrawingMode || update > 0) return
    const latLng = e.latLng
    if (!latLng) return
    setDrawingPoints((prev) => [...prev, { lat: latLng.lat(), lng: latLng.lng() }])
  }

  const handleClosePolygon = () => {
    if (drawingPoints.length < 3) return

    const latLngs = drawingPoints.map((p) => new google.maps.LatLng(p.lat, p.lng))

    setPath(latLngs)
    setUndoPolygon([latLngs])
    polygon?.setPaths(latLngs)

    const ha = calculoAreaCoord([latLngs])
    setArea(String(ha))
    setGetAreatalhao(ha)
    setKinksPoints(validateKinks(latLngs.map((p) => ({ lat: p.lat(), lng: p.lng() }))))

    setDrawingPoints([])
    setIsDrawingMode(false)
  }

  const handleRemoveLastPoint = () => {
    setDrawingPoints((prev) => prev.slice(0, -1))
  }

  const handleMarkerDragEnd = (index: number, e: google.maps.MapMouseEvent) => {
    if (!e.latLng) return
    setDrawingPoints((prev) =>
      prev.map((p, i) => (i === index ? { lat: e.latLng.lat(), lng: e.latLng.lng() } : p))
    )
  }

  const handleMouseUpPolygon = () => {
    const dados = polyGetPath(polygon)
    setUndoPolygon([...undoPolygon, dados])
    const ha = calculoAreaCoord([dados])
    setArea(String(ha))
    setGetAreatalhao(ha)
    setKinksPoints(validateKinks(dados))
  }

  const onFinish = async () => {
    try {
      loadingAlert({ msg: 'Aguarde...', id: 'cadastro_talhao' })

      const polygonFinish = polyGetPath(polygon)
      const kml = geralKmlPolygon(polygonFinish, nome)
      const cripto = btoa(kml)
      const arquivo = `data:@file/xml;base64,${cripto}`

      const dados = {
        nome: nome,
        cod_propriedade: propriedade,
        arquivo: arquivo,
        status: 1,
        area: String(area),
      }

      if (update <= 0) {
        const response = cultivavel
          ? await postTalhaoCultivavel(propriedade, dados)
          : await postTalhao(propriedade, dados)
        if (response.status === 201) {
          successAlert('Talhão cadastrado com sucesso!', 5000, 'cadastro_talhao')
          atualizar(propriedade, '')
          onClose?.(false);
        }
      } else {
        const response = cultivavel
          ? await putTalhaoCultivavel(propriedade, update, dados)
          : await putTalhao(propriedade, update, dados)
        if (response.status === 200) {
          successAlert('Talhão atualizado com sucesso!', 5000, 'cadastro_talhao')
          atualizar(propriedade, '');
          onClose?.(false);
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
        } else {
          data.error.forEach((item) => {
            errorAlert(item?.msg?.[0] ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
          })
        }
      } else {
        destroyAlert()
      }
    }
  }

  const handleSelectedUF = async (data) => {
    const response = await buscaCidade('', data, '')
    setListCity(response)
  }

  const handleClickCoord = () => {
    const lat = parseFloat(latitude)
    const lng = parseFloat(longitude)
    setCenter({ lat, lng })
    mapRef.current.state.map.zoom = 15
  }

  const handleClickCity = async () => {
    setLoadingBuscaCoord(true)

    const response = await buscaCidade('', '', cidadeId)
    const resp = response[0]

    const coord = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${resp.nome}+${resp.uf_sigla}&key=${process.env.REACT_APP_TOKEN_GOOGLE_MAPS}`
    )
    // @ts-ignore
    const location = coord.data?.results[0].geometry.location
    const { lat, lng } = location

    setCenter({ lat, lng })
    setZoom(15)
    setLoadingBuscaCoord(false)
  }

  const handleChangeTypeCenter = (data) => {
    setTypeBusca(data)
  }

  useEffect(() => {
    if (dataPolygon.coordenadas.length > 0) {
      const coord = dataPolygon.coordenadas

      setPath(coord)
      setUndoPolygon([coord])
      const ha = calculoAreaCoord([coord])
      setArea(String(ha))
      setNome(dataPolygon.nome)
      setZoom(12)

      const center = centerMap(coord)
      setCenter(center)
      setKinksPoints(validateKinks(coord))
    }
  }, [dataPolygon])

  useEffect(() => {
    setDrawingPoints([])
    setIsDrawingMode(true)
    setPath([])
    setArea('')
    setNome('')
    setUf('')
    setCidade('')
    setCidadeId(null)
    setLatitude('')
    setLongitude('')
    setKinksPoints([])
    setGetAreatalhao(0)
  }, [atualizar])

  useEffect(() => {
    handleListUf()
  }, [])

  const hasKinks = kinksPoints.length > 0
  const polygonColor = hasKinks ? '#ff4d4f' : 'cyan'

  const mapOptions: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    mapTypeControl: false,
    streetViewControl: false,
    draggableCursor: isDrawingMode && update <= 0 ? 'crosshair' : undefined,
  }

  return (
    <ContainerDesenho>
      <div className='Content__map'>
        <div className='Content__map__options' style={{ zIndex: 10 }}>
          <TitleH3>Ir para localização</TitleH3>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={encolher_card_localizacao ? faEyeSlash : faEye} />}
            onClick={() => setEncolher_card_localizacao(!encolher_card_localizacao)}
            type='secondary'
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          />
          <div className='Content__map__options__inputs' style={{ display: encolher_card_localizacao ? 'none' : 'flex' }}>
            <Switcher
              label='Busca por Coordenadas'
              isChecked={typeBusca}
              trigger={setTypeBusca}
            />
            {typeBusca ? (
              <>
                <Input
                  label='Latitude'
                  value={latitude}
                  onChange={setLatitude}
                  placeholder='Latitude'
                  icon={faLocationPinLock}
                />
                <Input
                  label='Longitude'
                  value={longitude}
                  onChange={setLongitude}
                  placeholder='Longitude'
                  icon={faLocationPinLock}
                />
              </>
            ) : (
              <>
                <Select
                  label='UF'
                  value={uf}
                  onChange={setUf}
                  onChangeID={handleSelectedUF}
                  items={getlistUf}
                  open={openUf}
                  trigger={setOpenUf}
                  idItem='cod'
                  descricaoItem='sigla'
                  icon={faFlag}
                  placeholder='Estado'
                />
                <Select
                  label='Cidade'
                  value={cidade}
                  onChange={setCidade}
                  onChangeID={setCidadeId}
                  items={getlistCity}
                  open={openCidade}
                  trigger={setOpenCidade}
                  idItem='cod'
                  descricaoItem='nome'
                  icon={faCity}
                  placeholder='Cidade'
                  disabled={!uf}
                />
              </>
            )}
            <ButtonCustom
              icon={<FontAwesomeIcon icon={faSearch} />}
              style={{ alignSelf: 'flex-start' }}
              onClick={typeBusca ? handleClickCoord : handleClickCity}
            >
              Buscar
            </ButtonCustom>
          </div>
        </div>

        <div className='Content__map__options' style={{ top: encolher_card_localizacao ? 68 : 268 }}>
          <TitleH3>Controle de desenho</TitleH3>
          <Inline gap={4} style={{ marginTop: 8 }}>
            <ButtonCustom
              onClick={handleUndo}
              icon={<FontAwesomeIcon icon={faUndo} />}
              title='Desfazer'
              type='secondary'
              disabled={undoPolygon.length <= 1}
            />
            <ButtonCustom
              onClick={handleRedo}
              icon={<FontAwesomeIcon icon={faRedo} />}
              title='Refazer'
              type='secondary'
              disabled={redoPolygon.length <= 0}
            />
            <DeleteButton
              loading={false}
              message={''}
              open={open_delete}
              trigger={setOpen_delete}
              disabled={getPath.length <= 0 && drawingPoints.length <= 0}
              onDelete={() => { handleResetDesenho(); setOpen_delete(false) }}
              typeButtonTrigger='primary'
              title='Tem certeza resetar o desenho dos polígonos?'
            />
            <ButtonCustom
              onClick={() => {
                if (isDrawingMode && drawingPoints.length >= 3) {
                  handleClosePolygon()
                } else {
                  setIsDrawingMode((prev) => !prev)
                  if (isDrawingMode) setDrawingPoints([])
                }
              }}
              icon={<FontAwesomeIcon icon={faDrawPolygon} />}
              type={isDrawingMode ? 'secondary' : 'primary'}
              disabled={isDrawingMode && drawingPoints.length < 3}
            >
              {isDrawingMode ? 'Fechar polígono' : 'Iniciar desenho'}
            </ButtonCustom>
          </Inline>
        </div>

        {/* @ts-ignore */}
        <GoogleMap
          ref={mapRef}
          onLoad={onLoadMap}
          onClick={handleMapClick}
          options={mapOptions}
          mapContainerStyle={{
            width: '100%',
            height: '81vh',
          }}
          center={getCenter}
          zoom={getZoom}
        >
          {isDrawingMode && drawingPoints.length > 0 && (
            <>
              <Polyline
                path={drawingPoints}
                options={{
                  strokeColor: 'cyan',
                  strokeWeight: 4,
                  geodesic: false,
                }}
              />
              {drawingPoints.map((point, index) => (
                <Marker
                  key={`dp_${index}`}
                  position={point}
                  draggable={index !== 0}
                  onDragEnd={(e) => handleMarkerDragEnd(index, e)}
                  onClick={index === 0 && drawingPoints.length >= 3 ? handleClosePolygon : undefined}
                  options={{
                    icon: {
                      path: google.maps.SymbolPath.CIRCLE,
                      scale: index === 0 && drawingPoints.length >= 3 ? 9 : 6,
                      fillColor: 'cyan',
                      fillOpacity: 1,
                      strokeColor: '#fff',
                      strokeWeight: index === 0 && drawingPoints.length >= 3 ? 3 : 2,
                    },
                    cursor: index === 0 && drawingPoints.length >= 3 ? 'pointer' : 'grab',
                  }}
                />
              ))}
            </>
          )}

          <Polygon
            onLoad={(data) => setPolygon(data)}
            paths={getPath}
            onMouseUp={handleMouseUpPolygon}
            onUnmount={onUnmount}
            options={{
              fillColor: polygonColor,
              strokeColor: polygonColor,
              strokeWeight: 4,
              fillOpacity: 0.45,
              clickable: true,
              draggable: false,
              editable: getPath.length > 0,
              geodesic: false,
            }}
          />

          {kinksPoints.map((point, index) => (
            <Marker
              key={`kink_${index}`}
              position={point}
              title='Linha sobreposta!'
              icon={{
                path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                fillColor: '#ff0000',
                fillOpacity: 1,
                strokeColor: '#000',
                strokeWeight: 1,
                scale: 1,
                labelOrigin: new window.google.maps.Point(0, -28),
              }}
              label={{ text: '!', color: 'white', fontWeight: 'bold' }}
            />
          ))}
        </GoogleMap>
      </div>

      <Box style={{ width: 300, minWidth: 300, height: 250 }} gap={16}>
        <TitleH3>Dados do talhão</TitleH3>

        <Input
          label='Nome do talhão'
          placeholder='Digite o nome do talhão'
          icon={faMapLocation}
          value={nome}
          onChange={setNome}
        />

        <Input
          label='Área (ha)'
          placeholder='0.00 ha'
          icon={faChartArea}
          value={area + ' ha'}
          onChange={() => { }}
          readOnly
        />

        <Inline justifyContent='space-between'>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            onClick={onFinish}
            style={{ alignSelf: 'flex-start' }}
            disabled={!nome || getAreatalhao === 0 || hasKinks}
          >
            Gerar Talhão
          </ButtonCustom>
        </Inline>
      </Box>
    </ContainerDesenho>
  )
}

export default DesenhaTalhaoNovo
